import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input, Button } from 'reactstrap'
import Select from "react-select";
import TableContainer from '../../Components/Common/TableContainerReactTable';
import Flatpickr from "react-flatpickr";
import ModalCrearRecepcionVehiculo from '../../Components/modals/ModalCrearRecepcionVehiculo';
import ModalLeerRecepcionVehiculo from '../../Components/modals/ModalLeerRecepcionVehiculo';
import ModalVerCita from '../../Components/modals/ModalVerCita';
import citasHooks from '../../Components/Hooks/CitasHooks';
import useCreateRecepcionVehiculo from '../../Components/Hooks/useCreateRecepcionVehiculo';
import ModalFormVehiculo from '../../Components/modals/ModalFormVehiculo';
import { set } from 'lodash';

const Citas = () => {
  const navigate = useNavigate();
  const [citaPrecargada, setCitaPrecargada] = useState({})
  const [patenteSeleccionada, setPatenteSeleccionada] = useState(null);
  const [estadoCitas, setEstadoCitas] = useState({ value: 'no_recepcionadas', label: "Sin recepcionar" })
  const d = new Date();
  let hoy = d.toISOString().substring(0, 10)
  const [fechaInicio, setFechaInicio] = useState(hoy)
  const [fechaTermino, setFechaTermino] = useState(hoy)

  const formatDate = (date) => {
    if (!date) return '';
    const _date = new Date(date)
    const year = _date.getFullYear();
    const month = String(_date.getMonth() + 1).padStart(2, '0');
    const day = String(_date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const citasFiltradas = () => {
    if (!Array.isArray(citas))
      return []
    switch (estadoCitas.value) {
      case 'todas':
        return citas
      case 'no_recepcionadas':
        return citas.filter(cita => cita.nrorecep == null)
      case 'recepcionadas':
        let res = citas.filter(cita => cita.nrorecep != null)
        return res
      default:
        return []
    }
  }

  const handleVerCita = (rowData) => {
    if (rowData.nrorecep != null) {
      // Cita ya recepcionada: abrir modal para ver la recepción existente
      setRecepcionSeleccionada(rowData.nrorecep);
      setModalLeerRecepcion(true);
    } else {
      // Cita no recepcionada: abrir modal para ver detalles de la cita
      setCitaSeleccionada(rowData);
      setModalVerCita(true);
    }
  }

  const handleRecepcionar = (rowData) => {
    // Construir objeto citaPrecargada desde rowData
    setCitaPrecargada({
      patente: typeof rowData.PATENT === 'string' ? rowData.PATENT : '',
      rut_contacto: typeof rowData.CLIENT === 'string' ? rowData.CLIENT.trim() : '',
      contacto: typeof rowData.OBSER2 === 'string' ? rowData.OBSER2.trim() : '',
      email: typeof rowData.MAICON === 'string' ? rowData.MAICON.trim() : '',
      telefono: typeof rowData.FONCON === 'string' ? rowData.FONCON.trim() : '',
      cita: rowData.NUMERO,
      tipo_trabajo_ot: rowData.TTRABA,
      solicitud_cliente: typeof rowData.OBSERV === 'string' ? rowData.OBSERV : ''
    });
    // Abrir modal de creación de recepción
    setModalCrear(true);
  }
  const handleEstadoCitasChange = (opcion) => {
    setEstadoCitas(opcion)
  }
  const handleFechaInicioChange = (date) => {
    setFechaInicio(formatDate(date[0]));
  };

  const handleFechaTerminoChange = (date) => {
    setFechaTermino(formatDate(date[0]));
  };

  const { citas, loading, error } = citasHooks(fechaInicio, fechaTermino);
  const { createRecepcion, loading: createLoading, error: createError } = useCreateRecepcionVehiculo();

  useEffect(() => {
    document.title = "Citas del Sistema | Siga ERP";
  }, []);


  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "NUMERO",
        enableColumnFilter: false,
      },
      {
        header: "Fecha",
        accessorKey: "fecha",
        enableColumnFilter: false,
      },
      {
        header: "Hora",
        accessorKey: "hora",
        enableColumnFilter: false,
      },
      {
        header: "Patente",
        accessorKey: "PATENT",
        enableColumnFilter: false,
      },
      {
        header: "Cliente",
        accessorKey: "CLIENT",
        enableColumnFilter: false,
      },
      {
        header: "Contacto",
        accessorKey: "OBSER2",
        enableColumnFilter: false,
      },
      {
        header: "Fono contacto",
        accessorKey: "FONCON",
        enableColumnFilter: false,
      },
      {
        header: "Tipo trabajo",
        accessorKey: "tipotrabajo",
        enableColumnFilter: false,
      },
      {
        header: "N° Recepción",
        accessorKey: "nrorecep",
        enableColumnFilter: false,
      },
      {
        header: "Acciones",
        accessorKey: "acciones",
        enableColumnFilter: false,
        cell: ({ row }) => (
          <div className="d-flex gap-2">
            <Button
              size="sm"
              color="info"
              onClick={() => handleVerCita(row.original)}
            >
              <i className="ri-eye-line me-1"></i>Ver
            </Button>
            <Button
              size="sm"
              color="primary"
              onClick={() => handleRecepcionar(row.original)}
              disabled={row.original.nrorecep != null}
            >
              <i className="ri-add-line me-1"></i>Recepcionar
            </Button>
          </div>
        )
      }
    ],
    []
  );



  const [modalCrear, setModalCrear] = useState(false);
  const [modalModificarVehiculo, setModalModificarVehiculo] = useState(false);
  const [modalVerCita, setModalVerCita] = useState(false);
  const [modalLeerRecepcion, setModalLeerRecepcion] = useState(false);
  const [citaSeleccionada, setCitaSeleccionada] = useState(null);
  const [recepcionSeleccionada, setRecepcionSeleccionada] = useState(null);
  const toggleModalCrear = () => {
    setModalCrear(!modalCrear);
  };

  const toggleModalVehiculo = () => {
    setModalModificarVehiculo(!modalModificarVehiculo);
  };

  const toggleModalVerCita = () => {
    setModalVerCita(!modalVerCita);
  };

  const toggleModalLeerRecepcion = () => {
    setModalLeerRecepcion(!modalLeerRecepcion);
  };


  const handleGuardarVehiculo = () => {
    // Lógica para guardar el vehículo modificado
    setModalModificarVehiculo(false);
  };

  const handleCrear = () => {
    setModalCrear(true);
  }

  const handleModalVehiculo = () => {
    setModalModificarVehiculo(true);
  };



  const handleGuardarRecepcion = async (datosRecepcion) => {
    const result = await createRecepcion(datosRecepcion);
    if (result.success) {
      setModalCrear(false);
      navigate('/servicios/historial-recepciones', {
        state: { verRecepcion: result.data.id_recep }
      });
    }
    // Error is handled in the hook
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Citas</h5>
                  <div className="d-flex align-items-center">
                    <Label className="form-label mb-0 me-2">Estado</Label>
                    <div className="mt-0  me-2">
                      <Select
                        id="Estado"
                        value={estadoCitas}
                        onChange={handleEstadoCitasChange}
                        options={[
                          { value: 'todas', label: 'Todas' },
                          { value: 'no_recepcionadas', label: 'Sin recepcionar' },
                          { value: 'recepcionadas', label: 'Recepcionadas' }]}
                        onFocus={(e) => {
                          e.target.readOnly = true;
                        }}
                      />
                    </div>
                    <Label className="form-label mb-0 me-2">Desde</Label>
                    <div className="mt-0  me-2">
                      <Flatpickr
                        className="form-control"
                        options={{
                          mode: "single",
                          dateFormat: "Y-m-d"
                        }}
                        value={fechaInicio}
                        onChange={handleFechaInicioChange}
                      />
                    </div>
                    <Label className="form-label mb-0 me-2">Hasta</Label>
                    <div className="mt-0">
                      <Flatpickr
                        className="form-control"
                        options={{
                          mode: "single",
                          dateFormat: "Y-m-d"
                        }}
                        value={fechaTermino}
                        onChange={handleFechaTerminoChange}
                      />
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  {loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                    columns={(columns || [])}
                    data={citasFiltradas()}
                    customPageSize={15}
                    isGlobalFilter={true}
                    SearchPlaceholder='Buscar...'
                  />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ModalCrearRecepcionVehiculo
        isOpen={modalCrear}
        toggle={toggleModalCrear}
        onSave={handleGuardarRecepcion}
        citaPrecargada={citaPrecargada}
      />
      <ModalFormVehiculo
        mode="modify"
        isOpen={modalModificarVehiculo}
        toggle={toggleModalVehiculo}
        onSave={handleGuardarVehiculo}
        selectedVehiculo={patenteSeleccionada} />
      <ModalVerCita
        isOpen={modalVerCita}
        toggle={toggleModalVerCita}
        cita={citaSeleccionada}
      />
      <ModalLeerRecepcionVehiculo
        isOpen={modalLeerRecepcion}
        toggle={toggleModalLeerRecepcion}
        idRecepcion={recepcionSeleccionada}
      />
    </React.Fragment>
  )
}

export default Citas;